<script>
    import { onMount } from 'svelte';

    import model from '../../stores/modelStore';
    import { projectSettings } from '../../config';

    import PageSection from '../../components/PageSection.svelte';
    import Form from '../../components/Form.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
    import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    export let pageTitle = null;
    
	let buttons;

    document.title = pageTitle;


</script>

<PageSection>
	<Form id="form-landing-page">
        <FormRow class="justify-content-center confirmation-hide">
            <FormColumn>
                <h1 class="text-center">{@html projectSettings.classActionName}</h1>
            </FormColumn>
        </FormRow>

        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    Hello {$model.firstName} {$model.surname}.
                </p>
                <p>
                    The deadline to provide further evidence and medical records for the Astora Mesh Class Action was 4.00PM AEDT on Wednesday, 19 March 2025. 
                </p>
            </FormColumn>
        </FormRow>


        <FormRow class="justify-content-md-center confirmation-hide">
            <FormColumn>
                <p>
                    If you missed the deadline and would like to discuss the impact of this with a member of our team, please contact us on
                    <ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
                    <ClassActionEmailAddress></ClassActionEmailAddress>.
                </p>
            </FormColumn>
        </FormRow>
    </Form>
</PageSection>

<style>
    h1 {
        margin-bottom: 20px;
    }
</style>


